import { createContext } from 'react';

const LaunchPlanContext = createContext({
  currentStep: '',
});

export default LaunchPlanContext;
